import React from 'react';
import { Spin, Typography, Collapse, Icon } from 'antd';
import { useActiveShutdowns } from '../../api';
import PanelHeader from '../PanelHeader/PanelHeader';
import ShutdownDetails from '../ShutdownDetails/ShutdownDetails';
import styles from './ActiveShutdowns.module.scss';

const { Text } = Typography;
const { Panel } = Collapse;

const ActiveShutdowns = ({ houseId }) => {
  const { data: activeShutdowns, isFetching } = useActiveShutdowns(houseId, {
    enabled: Boolean(houseId),
  });

  if (!houseId) {
    return null;
  }

  return (
    <Spin
      spinning={isFetching || false}
      wrapperClassName={styles.root}
    >
      {activeShutdowns?.length ? (
        <>
          <p className={styles.title}>Активные отключения</p>
          <Collapse
            className={styles.collapse}
            expandIcon={({ isActive }) => (
              <Icon
                type="caret-right"
                rotate={isActive ? 90 : 0}
              />
            )}
          >
            {activeShutdowns.map((shutdown, index) => (
              <Panel
                key={shutdown.alertId || shutdown.id}
                className={styles.panel}
                header={
                  <PanelHeader
                    index={index + 1}
                    shutdown={shutdown}
                  />
                }
              >
                <ShutdownDetails shutdown={shutdown} />
              </Panel>
            ))}
          </Collapse>
        </>
      ) : (
        <Text>{isFetching ? '' : 'Активные отключения отсутствуют'}</Text>
      )}
    </Spin>
  );
};

export default ActiveShutdowns;
